import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return `${appStore.daraApiBaseUrl}/organisations/`
  },

  adviserNotes(id: number, data: object) {
    return axios.post(this.baseUrl() + `${id}/reports/adviser-notes`, data)
  },

  myUCPersonalStatement(id: number, data: object) {
    return axios.post(this.baseUrl() + `${id}/reports/myuc/personal-statement`, data)
  },
}
